import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { getShowArchiveFilterConfig } from '@/bundles/GroupFilters/helpers/filtersConfig/getShowArchiveFilterConfig';

export const getMarketingCampaignFilters = (): IFilterConfigItem[] => {
  return [
    // FilterCategoryEnum.marketing_campaign_details start
    {
      title: 'Status',
      name: 'status',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: [
        { text: 'Sent', value: 'sent' },
        { text: 'Pending', value: 'pending' },
        { text: 'Pending Sent', value: 'pending_sent' },
      ],
      category: FilterCategoryEnum.marketing_campaign_details,
    },
    {
      title: 'Marketing Template',
      name: 'marketing_template_id',
      type: FilterTypeEnum.marketing_template_autocomplete,
      category: FilterCategoryEnum.marketing_campaign_details,
    },
    // FilterCategoryEnum.marketing_campaign_details end
    getShowArchiveFilterConfig(),
  ].filter(Boolean) as IFilterConfigItem[];
};
